<template>
  <BuyerOneColumnPage
    :title="title"
    subTitle="Avaliação sob aprovação não concretizadas em compra"
    :icon="icon"
    :section="section"
    :description="description"
    :getContent="getOnDemandAssessmentdUnfufilled"
    labelCard="Sua última avaliação"
    buyerScope="UnfulilledPurchases"
    noVehicleLabel="Você ainda não avaliou nenhum veículo…"
    priceBackgroundColor="#F22300"
  />
</template>

<script>
import { BUYER_SECTION_CLOSED } from "@/views/buyer/constants/BuyerSections";

import PlatformsMixins from "@/mixins/PlatformsMixins";
import BuyerComponentPagesMixins from "@/mixins/BuyerComponentPagesMixins";

import { getOnDemandAssessmentdUnfufilled } from "@/services/api/BuyerServiceApi";

import BuyerOneColumnPage from "../../BuyerOneColumnPage";

export default {
  name: "OnDemandAssessmentUnfulfilledPurchasesPage",
  mixins: [PlatformsMixins, BuyerComponentPagesMixins],
  components: { BuyerOneColumnPage },
  data: function () {
    return {
      ...BUYER_SECTION_CLOSED,
      title: "Não concretizadas - Avaliações sob aprovação rejeitadas",
      section: "Encerrados",
    };
  },
  methods: {
    getOnDemandAssessmentdUnfufilled,
  },
};
</script>

<style scoped></style>
